var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconActionHelpOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.167 15h1.666v-1.667H9.167V15zM10 1.667A8.336 8.336 0 001.667 10c0 4.6 3.733 8.333 8.333 8.333S18.333 14.6 18.333 10 14.6 1.667 10 1.667zm0 15A6.676 6.676 0 013.333 10 6.676 6.676 0 0110 3.333 6.676 6.676 0 0116.667 10 6.676 6.676 0 0110 16.667zM10 5a3.332 3.332 0 00-3.333 3.333h1.666c0-.916.75-1.666 1.667-1.666s1.667.75 1.667 1.666c0 1.667-2.5 1.459-2.5 4.167h1.666c0-1.875 2.5-2.083 2.5-4.167A3.332 3.332 0 0010 5z",
    fill: "#2C3032",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "dbc981bfc3cb72e8a9c21b92c31dc9cc.svg";
export { SvgIconActionHelpOutline as ReactComponent };